import { NavLink } from "react-router-dom";

const ITEMS = [
    { to: "/portal/dashboard", label: "Dashboard" },
    { to: "/portal/courses", label: "Catalog" },
    { to: "/portal/certificates", label: "Certificates" },
];

export default function PortalSubnav() {
    return (
        <div
            className="border-b border-brand-line bg-white"
            data-testid="portal-subnav"
        >
            <div className="container-x flex items-center gap-6 overflow-x-auto py-4">
                {ITEMS.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        end
                        className={({ isActive }) =>
                            `whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${
                                isActive
                                    ? "text-brand-gold"
                                    : "text-brand-charcoal hover:text-brand-gold"
                            }`
                        }
                        data-testid={`portal-subnav-${item.label.toLowerCase()}`}
                    >
                        {item.label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}
